module.exports = __webpack_public_path__ + "static/media/yangzi.16bf9b05.png";